import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FIND_PRODUCT = function (state, payload) {
  state.row = payload
}
mutations.GET_CATEGORY = function (state, payload) {
  state.category = payload
}
mutations.PURCHASE_ID = function (state, payload) {
  state.purchase_id = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  category: [],
  purchase_id: null
}
const actions = {
  init: ({ commit, state }) => {
    const ctx = {
      data: {
        init: { api: 'M0002LandingPageService.searchProduct' },
        getCategory: { api: 'M0002LandingPageService.getCategory' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('FIND_ALL', data.init.output)
        commit('GET_CATEGORY', data.getCategory.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0002LandingPage cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchProduct: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0002LandingPageService.searchProduct', input: condition } } })
      .then((data) => {
        commit('FIND_ALL', data.search.output)
      })
  },
  getProductDetail: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { findProduct: { api: 'M0002LandingPageService.searchProduct', input: condition } } })
      .then((data) => {
        commit('FIND_PRODUCT', data.findProduct.output)
      })
  },
  getCategory: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { getCategory: { api: 'M0002LandingPageService.getCategory', input: condition } } })
      .then((data) => {
        commit('GET_CATEGORY', data.getCategory.output)
      })
  },
  checkOut: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage checkOut')
    return client.postData({ data: { checkOut: { api: 'M0004PurchaseMasterService.savePurchase', input: condition } } })
      .then((data) => {
        commit('PURCHASE_ID', data.checkOut.output['id'])
        localStorage.purchase_list = JSON.stringify(data.checkOut.output['pmDet_rows'])
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0002LandingPage add')
    commit('EDIT',
      {
        id: null
        // files: {},
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0002LandingPage edit')
    return client.postData({ data: { find: { api: 'M0002LandingPageService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0002LandingPage delete')
    return client.postData({ data: { delete: { api: 'M0002LandingPageService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0002LandingPage save')
    return client.postData({ data: { save: { api: 'M0002LandingPageService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage download')
    return client.download({ data: { download: { api: 'M0002LandingPageService.downloadData', input: condition } } })
  },
  addToCart: ({ commit, state }, row) => {
    console.debug('called M0002LandingPage save')
    return client.postData({ data: { save: { api: 'M0003ShoppingCartService.saveToCart', input: row } } })
      .then((data) => {
        // commit('SAVE', data.save.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
